const RFIDStatus = {
  Success: "success",
  Pending: "pending",
  Failed: "failed",
  Voided: "voided",
};

export default RFIDStatus;
